
    import { defineComponent } from 'vue'
    import { iFilter, iLov } from '../../KpiScheduler'
    import Card from 'primevue/card'
    import KpiSchedulerFilterDetailCard from './KpiSchedulerFilterDetailCard.vue'

    export default defineComponent({
        name: 'kpi-scheduler-filters-card',
        components: { Card, KpiSchedulerFilterDetailCard },
        props: { formatedFilters: { type: Object, required: true }, placeholderType: { type: Array }, temporalType: { type: Array }, lovs: { type: Array, required: true } },
        emits: ['touched'],
        data() {
            return {
                filters: [] as iFilter[],
                kpiNames: [] as string[],
                filteredLovs: [] as iLov[]
            }
        },
        watch: {
            formatedFilters() {
                this.loadFilters()
            }
        },
        created() {
            this.loadFilters()
        },
        methods: {
            loadFilters() {
                this.filters = this.formatedFilters as any[]
                if (this.filters) {
                    this.kpiNames = Object.keys(this.filters)
                }
            }
        }
    })
